<template>
	<div class="c-filters-bar__layout c-people-listing__filter-bar-layout">
		<div class="c-filters-wrapper" ref="filtersWrapper" data-flyout-panel="filter">
			<header class="c-filters-header mobile-only ">
				<h2 class="c-filters-header__heading">Filters</h2>
				<button class="c-filters-header__button iconf-close"
						data-flyout-toggle="filter"></button>

			</header>
			<div v-for="(options, groupName) in groupedFilterOptions" :key="groupName" :class="['c-filter-group', { 'is-showing': showingGroups[groupName] }]">
				<button class="c-filter-group__button" type="button" aria-label="show filters" @click="toggleGroup(groupName)">
					Select {{ groupName }}
				</button>
				<ul class="c-filters">
					<li class="c-filter" :key="groupName + '-all'">
						<label class="c-filter__label">
							<input class="c-filter__input"
								   type="checkbox"
								   :checked="isAllChecked(groupName)"
								   @change="onAllChange(groupName, $event)" />
							All
						</label>
					</li>
					<li class="c-filter" v-for="option in options" :key="option.id">
						<label class="c-filter__label">
							<input class="c-filter__input"
								   type="checkbox"
								   :value="option.id"
								   v-model="option.selected"
								   @change="onOptionChange(groupName)" />
							{{ option.name }}
						</label>
					</li>
				</ul>
			</div>
		</div>
	</div>

	<div class="c-filters-active" v-if="hasActiveFilters">
		<div class="c-filters-active-wrapper">
			<div class="c-filters-active__label">Filter by:</div>
			<span class="c-filters-active__item"
				  v-for="(name, index) in activeFilterNames"
				  :key="name + index"
				  @click="removeActiveFilter(name)">
				{{ name }}
			</span>
			<button class="c-filters__reset" type="button" @click="clearAllFilters">Clear Filters</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'filtersModule',
		emits: ['filters-changed', 'toggle-filters'],
		props: {
			filters: {
				type: Object,
				required: false
			},
			filterIsShowing: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				showingGroups: {},
				isDocumentListenerBound: false,
				isActive: false
			};
		},
		computed: {
			groupedFilterOptions() {
				return this.filters.filters.reduce((groups, filter) => {
					if (!groups[filter.name]) {
						groups[filter.name] = [];
					}
					groups[filter.name].push(...(filter.filterOptions || []));
					return groups;
				}, {});
			},
			hasActiveFilters() {
				return this.filters.filters.some(filter =>
					(filter.filterOptions || []).some(option => option.selected)
				);
			},
			activeFilterNames() {
				return this.filters.filters
					.flatMap(filter => (filter.filterOptions || []))
					.filter(option => option.selected)
					.map(option => option.name);
			}
		},
		watch: {
			showingGroups: {
				handler(newVal) {
					const anyOpen = Object.values(newVal).some(Boolean);
					if (anyOpen && !this.isDocumentListenerBound) {
						document.addEventListener('click', this.handleClickOutside);
						this.isDocumentListenerBound = true;
					} else if (!anyOpen && this.isDocumentListenerBound) {
						document.removeEventListener('click', this.handleClickOutside);
						this.isDocumentListenerBound = false;
					}
				},
				deep: true
			}
		},
		mounted() {
			//document.addEventListener('click', this.handleClickOutside);
		},
		beforeUnmount() {
			if (this.isDocumentListenerBound) {
				document.removeEventListener('click', this.handleClickOutside);
			}
		},
		methods: {
			toggleGroup(groupName) {
				// Toggle visibility of filter group dropdown
				const isCurrentlyOpen = !!this.showingGroups[groupName];
				Object.keys(this.groupedFilterOptions).forEach(name => {
					this.showingGroups[name] = false;
				});
				this.showingGroups[groupName] = !isCurrentlyOpen;
			},
			isAllChecked(groupName) {
				// "All" is checked when no options are selected in this group
				const options = this.groupedFilterOptions[groupName] || [];
				return options.every(option => !option.selected);
			},
			onAllChange(groupName, event) {
				const options = this.groupedFilterOptions[groupName] || [];

				// Only allow checking "All", not unchecking it
				if (event.target.checked) {
					// When "All" is checked, uncheck all options in this group
					options.forEach(option => {
						option.selected = false;
					});
					this.emitSelected();
				} else {
					// Prevent unchecking "All" - keep it checked
					event.preventDefault();
					event.target.checked = true;
				}
			},
			onOptionChange(groupName) {
				const options = this.groupedFilterOptions[groupName] || [];

				// Check if all options in this group are now selected
				const allSelected = options.every(option => option.selected);

				if (allSelected) {
					// If all are selected, deselect all and "All" will become checked
					options.forEach(option => {
						option.selected = false;
					});
				}

				this.emitSelected();
			},
			emitSelected() {
				const selected = [];
				this.filters.filters.forEach(filter => {
					(filter.filterOptions || []).forEach(option => {
						if (option.selected) {
							selected.push(option.id);
						}
					});
				});
				this.$emit('filters-changed', selected);
			},
			removeActiveFilter(name) {
				// Remove filter when active filter tag is clicked
				this.filters.filters.forEach(filter => {
					(filter.filterOptions || []).forEach(option => {
						if (option.name === name) {
							option.selected = false;
						}
					});
				});
				this.emitSelected();
			},
			handleClickOutside(event) {
				const wrapper = this.$refs.filtersWrapper;
				if (wrapper && !wrapper.contains(event.target)) {
					Object.keys(this.showingGroups).forEach(name => {
						this.showingGroups[name] = false;
					});
				}
			},
			clearAllFilters() {
				this.filters.filters.forEach(filter => {
					(filter.filterOptions || []).forEach(option => {
						option.selected = false;
					});
				});
				this.emitSelected();
				localStorage.removeItem('listing-filters');
			}


		}
	};
</script>
